import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Contact from "@/pages/Contact";
import PrivateGp from "@/pages/PrivateGp";
import CorporateScreening from "@/pages/CorporateScreening";
import NhsPrimaryCare from "@/pages/NhsPrimaryCare";
import ClinicalResearch from "@/pages/ClinicalResearch";
import IndustryAcademic from "@/pages/IndustryAcademic";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import { CookieConsent } from "@/components/CookieConsent";
import PortalLayout from "@/pages/portal/PortalLayout";
import Dashboard from "@/pages/portal/Dashboard";
import Referrals from "@/pages/portal/Referrals";
import Directory from "@/pages/portal/Directory";
import Admin from "@/pages/portal/Admin";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center bg-navy">
        <span className="font-mono text-xs tracking-[0.35em] text-gold">AUTHENTICATING…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/private-gp" element={<PrivateGp />} />
          <Route path="/corporate-screening" element={<CorporateScreening />} />
          <Route path="/nhs-primary-care" element={<NhsPrimaryCare />} />
          <Route path="/clinical-research" element={<ClinicalResearch />} />
          <Route path="/industry-academic" element={<IndustryAcademic />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route
            path="/portal"
            element={
              <Protected>
                <PortalLayout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="directory" element={<Directory />} />
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
        <CookieConsent />
      </BrowserRouter>
    </AuthProvider>
  );
}
